import { Fees, MortgagePreferences } from "models/ApplicationSummaryEnhanced"
import React from "react"

interface FeesCopyProps {
  preference: MortgagePreferences["fees"]
  feeAmount: number
}

const NoFeesCopy = () => (
  <>
    You have chosen a mortgage product with <strong>no arrangement fees</strong>. This option
    ensures you do not have to pay an application fee upfront or incur additional interest by adding
    fees to your total loan amount.
  </>
)

const AddToTheLoanCopy = () => (
  <>
    You chose to <strong>add the fees to your mortgage</strong> to avoid a large upfront cost. You
    understand this will increase the total interest you pay over the life of the loan.
  </>
)

const PayUpFrontCopy = () => (
  <>
    You chose to <strong>pay the fees up front</strong> to keep your total loan amount as low as
    possible and avoid paying any extra interest.
  </>
)

export const FeesCopy = ({ preference, feeAmount }: FeesCopyProps) => {
  switch (preference.type) {
    case Fees.NoFees:
      return <NoFeesCopy />
    case Fees.AddToTheLoan:
      return <AddToTheLoanCopy />
    case Fees.PayUpFront:
      return <PayUpFrontCopy />
    default:
      return null
  }
}
